import { defineComponent as C, ref as s, computed as c, watch as m, onMounted as T, nextTick as _, onBeforeUnmount as b } from "vue";
import { throttle as z } from "lodash-es";
import H from "./td-longtail-vue-components18.js";
import L from "./td-longtail-vue-components4.js";
import Z from "./td-longtail-vue-components3.js";
const U = /* @__PURE__ */ C({
  __name: "image-gallery-2023",
  props: {
    images: { default: void 0 },
    initialSelectedIndex: { default: 0 },
    noZoom: { type: Boolean },
    thumbnailLabel: { default: "Bilder auswählen" },
    textZoom: { default: "Vergrößern" },
    textSelectImage: { default: "Bild Anzeigen" },
    textControlGroup: { default: "Bilder Navigation" },
    textPrevControl: { default: "Vorheriges Bild" },
    textNextControl: { default: "Nächstes Bild" }
  },
  emits: ["zoom", "selected-image"],
  setup(x, { expose: S, emit: u }) {
    const o = x, t = s(o.initialSelectedIndex), d = s(!1), v = s(!1), e = s(null), a = c(() => o.images?.length || 0), i = c(() => a.value > 1), r = c(
      () => o.images?.[t.value]
    ), n = (l) => {
      if (l >= a.value) {
        t.value = 0;
        return;
      }
      if (l < 0) {
        t.value = a.value - 1;
        return;
      }
      t.value = l;
    }, f = () => {
      n(t.value + 1);
    }, g = () => {
      n(t.value - 1);
    }, p = () => {
      o.noZoom || u("zoom", {
        zoomParams: o.textZoom.toLowerCase(),
        selectedImageIndex: t.value,
        selectedImage: r.value
      });
    }, h = () => {
      if (!e.value) return;
      const l = Math.abs(
        e.value.scrollHeight - e.value.scrollTop - e.value.clientHeight
      ) < 3;
      d.value = e.value.scrollTop !== 0, v.value = !l;
    }, I = z(h, 200), B = () => {
      e.value && (e.value.scrollTop -= e.value.clientHeight);
    }, w = () => {
      e.value && (e.value.scrollTop += e.value.clientHeight);
    };
    return m(
      () => o.initialSelectedIndex,
      (l) => {
        n(l);
      }
    ), m(
      () => o.images,
      () => {
        t.value = 0, n(0);
      }
    ), m(r, (l) => {
      l && u("selected-image", l);
    }), T(() => {
      i.value && _(() => {
        setTimeout(() => {
        }, 500);
      });
    }), b(() => {
      e.value?.addEventListener("scroll", I);
    }), S({
      incrementSelectedImageIndex: f,
      decrementSelectedImageIndex: g,
      selectedImageIndex: t,
      selectedImage: r,
      selectImage: n,
      imageCount: a,
      hasMultipleImages: i,
      emitClick: p
    }), { __sfc: !0, props: o, emit: u, selectedImageIndex: t, showScrollUpButton: d, showScrollDownButton: v, thumbnailsContainerElement: e, imageCount: a, hasMultipleImages: i, selectedImage: r, selectImage: n, incrementSelectedImageIndex: f, decrementSelectedImageIndex: g, emitClick: p, handleScroll: h, onScroll: I, scrollUp: B, scrollDown: w, GoliathImageElement: H, Arrow: L, LinkButton: Z };
  }
});
export {
  U as default
};
